
















import _ from "lodash";
import moment from "moment-timezone";
import sanitize from "sanitize-filename";
import slugify from "slugify";

import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";

import { Photo } from "@/models";
import { MaintenancejobsState } from "@/store/maintenancejobs/types";

@Component
export default class PhotoComponent extends Vue {
  @State("maintenancejob") public maintenancejobsState: MaintenancejobsState;

  @Prop() public photo: Photo;

  @Prop() public galleryType: "string";

  @Prop({ default: false }) public isLogo: boolean;
	@Prop({default: true}) public showPhotoActions: boolean;

  public onRotate(event: any) {
    this.$emit("rotate", this.photo);
  }

  public onDelete(event: any) {
    this.$emit("delete", this.photo);
  }

  /**
   * Open a Photo in the Gallery.
   *
   * The Gallery page makes an API call to "get all the Photos in a Maintenancejob", so
   * any Photos added in the CMS will not be available in the Gallery until the
   * changes to the Maintenancejob (the new Photos) have been saved to the database.
   */
  public openPhotoInGallery() {
    if (this.isLogo) return;
    // if (this.photo.hasGalleryLink) {
    // const url = this.$onecentral.photoGalleryUrl(
    //   this.photo,
    //   this.maintenancejobsState.current,
    //   this.galleryType
    // );
    // window.open(url, "_blank");
    // } else {
    //   this.$onecentral.displayError('This image has not been saved to the Maintenancejob.');
    // }
  }
}
